import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';

function isValidDate(d) {
    try {
        // eslint-disable-next-line
        return d.getTime() === d.getTime();
    } catch (e) {
        return false;
    }

}
export default class DatePickerValue extends React.Component {
    state = {
        currentValue: '',
    }

    componentDidMount() {
        let currentDate = new Date(this.props.value);
        let isValid = isValidDate(currentDate);
        this.setState({ ...this.state, currentValue:  this.props.value && isValid ? currentDate.toLocaleDateString() : '' });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            let currentDate = new Date(this.props.value);
            let isValid = isValidDate(currentDate);
            this.setState({ ...this.state, currentValue:  this.props.value && isValid ? currentDate.toLocaleDateString() : '' });
        }
    }

    handlerChangeCurrent = (event)=>{
        const value = event.target.value;
        if (!isNaN(Number(value.replace('/', '').replace('/', '')))) {
            this.setState({ ...this.state, currentValue: value });
        }
    }

    render() {
        const { readOnly, value, handlerChange, name, currentId, label } = this.props;
        const { currentValue } = this.state;
        return (
            <React.Fragment>
                <label>{label}</label>
                <DatePicker
                    readOnly={readOnly}
                    disabled={readOnly}
                    dateFormat='DD/MM/YYYY'
                    value={currentValue}
                    placeholderText='DD/MM/AAAA'
                    selected={value ? moment(value) : null }
                    name={name}
                    id={currentId}
                    onChangeRaw={this.handlerChangeCurrent}
                    onChange={(date) => {
                        if (date) {
                            handlerChange(date, ()=> this.setState({ ...this.state, currentValue:  new Date(date.toISOString()).toLocaleDateString() }));
                        }
                    }}/>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/datepicker.js